import * as React from 'react';
import { Form, Input, Switch, Tooltip } from 'antd';
import { getClassNames } from '../../utils';
import { InfoCircleOutlined } from '@ant-design/icons';
export var DeliveryThrottlingEditor = function DeliveryThrottlingEditor(_ref) {
  var enabled = _ref.enabled,
      handleEnabled = _ref.handleEnabled;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassNames('notif-delivery-throttling-editor')
  }, /*#__PURE__*/React.createElement(Form.Item, {
    label: /*#__PURE__*/React.createElement("span", null, "Delivery Throttle", /*#__PURE__*/React.createElement(Tooltip, {
      title: "The Delivery Throttle will spread all non-campaign notification sends over the specified period of time. This can be used to ensure landing page servers are not overloaded by a large influx of traffic in a short period of time. The maximum allowable throttle is 15 minutes."
    }, /*#__PURE__*/React.createElement(InfoCircleOutlined, null)))
  }, /*#__PURE__*/React.createElement("div", {
    className: "notif-delivery-throttle"
  }, /*#__PURE__*/React.createElement(Switch, {
    size: "small",
    checked: enabled,
    onChange: function onChange(checked) {
      return handleEnabled(checked);
    }
  }), /*#__PURE__*/React.createElement("div", null, "Notification sends should be spread over"), /*#__PURE__*/React.createElement("div", {
    className: "notif-delivery-throttle-input ".concat(enabled ? '' : 'disabled')
  }, /*#__PURE__*/React.createElement(Form.Item, {
    name: "deliveryThrottleMaxSeconds",
    noStyle: true,
    rules: [{
      validator: function validator(rule, value, callback) {
        if (enabled && !(value > 0)) {
          return Promise.reject('Delivery throttle must be greater than 0');
        }

        return Promise.resolve();
      }
    }]
  }, /*#__PURE__*/React.createElement(Input, {
    disabled: !enabled,
    size: "middle",
    type: "number",
    min: 1,
    max: 15,
    addonAfter: "minute(s)"
  }))))));
};